import React, { Fragment } from 'react';
import { array, func, number, shape, string } from 'prop-types';

import ListBox from './ListBox';
import TextBox from '@components/TextBox/TextBox';
import ImportImages from '@src/importImages';

const clouds = ImportImages('/home/clouds.jpg');
const jsiLogo = ImportImages('/jsi-logo.png');

const propTypes = {
  activeBox: shape({
    content: string.isRequired,
    header: string.isRequired,
    id: number.isRequired
  }).isRequired,
  boxes: array.isRequired,
  className: string.isRequired,
  handleClick: func.isRequired,
  mainContent: shape({
    content: string.isRequired,
    header: string.isRequired,
    id: number.isRequired
  }).isRequired
};

const Mobile = ({ activeBox, boxes, className, handleClick, mainContent }) => {
  const sectionStyles = {
    backgroundImage: `url(${clouds}), url(${jsiLogo})`,
    backgroundBlendMode: 'multiply',
    backgroundSize: '100% 100%',
    backgroundPosition: 'top center',
    height: '500px'
  };

  const textBoxStyles = {
    marginTop: '15rem',
    width: '100%'
  };

  const renderBoxes = boxes => {
    return boxes.map(box => {
      return (
        <ListBox
          activeBoxId={activeBox.id}
          box={box}
          className={className}
          key={box.id}
          onClick={() => handleClick(box)}
        />
      );
    });
  };

  return (
    <Fragment>
      <div
        className={'d-flex align-items-center pt-5 pb-5 pl-2 pr-2 w-100'}
        style={sectionStyles}
      >
        <TextBox {...mainContent} style={textBoxStyles} isHeader={true} />
      </div>

      {renderBoxes(boxes)}
    </Fragment>
  );
};

Mobile.propTypes = propTypes;

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Partners/Mobile/Mobile.jsx